module.exports = __webpack_public_path__ + "assets/img/nav_bg5.37b7d136.png";